"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogoContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../assets/styles/config");
exports.StyledLogoContainer = styled_components_1.default.div `
  align-items: center;
  background: ${config_1.colors.midnight};
  display: flex;
  height: 70px;
  justify-content: center;
  width: 100%;
  @media ${config_1.device.tablet} {
    justify-content: flex-start;
    width: 250px;
  }
`;
